import classNames from 'classnames';
import React, { FC } from 'react';

import { Checkbox, CheckboxShape } from '../Checkbox/Checkbox';
import { FieldProps } from '../types';
import styles from './CheckboxField.styles.m.css';

interface ICheckboxFieldProps extends Omit<FieldProps, 'value' | 'onChange'> {
  onChange: (isChecked: boolean) => void;
  value: boolean;
  contentClassName?: string;
}

export const CheckboxField: FC<ICheckboxFieldProps> = (props) => {
  const {
    message,
    className,
    contentClassName,
    value,
    label,
    hasError,
    isDisabled,
    onChange,
    onBlur,
    onFocus,
    id,
    name,
  } = props;

  const containerClassName = classNames(styles.container, className, {
    [styles.hasError]: hasError,
    [styles.disabled]: isDisabled,
  });

  return (
    <div className={containerClassName}>
      <label className={classNames(styles.content, contentClassName)}>
        <Checkbox
          id={id}
          name={name}
          isChecked={value}
          shape={CheckboxShape.Square}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          isDisabled={isDisabled}
          className={styles.checkbox}
        ></Checkbox>
        <span className={styles.label}>{label}</span>
      </label>
      {message && <div className={styles.message}>{message}</div>}
    </div>
  );
};
